import * as Yup from "yup";

export const productsSchema = Yup.object().shape({
  name: Yup.string().required("Məhsulun adı tələb olunur"),
  price: Yup.number().required("Məhsulun qiyməti tələb olunur"),
  description: Yup.string().required("Məhsulun təsviri tələb olunur"),
  category_id: Yup.number().required("Məhsulun kateqoriyası tələb olunur"),
  cover_image: Yup.string().required("Məhsulun şəkili tələb olunur"),
  tracking_number: Yup.string().required("Məhsulun izlənmə kodu tələb olunur"),
  model_code: Yup.string().required("Məhsulun model kodu tələb olunur"),
  product_group: Yup.string().required("Məhsulun aid olduğu qrup tələb olunur"),
  warehouse_id: Yup.string().required("Məhsulun olduğu anbar tələb olunur"),
});
